@if (noSubmittedPosts()) {
<div class="flex flex-col items-center justify-center h-full px-8 py-10 text-center">
    <div
        class="flex items-center justify-center size-16 rounded-2xl bg-violet-50 dark:bg-violet-500/10 mb-5 ring-1 ring-inset ring-violet-500/20">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            aria-hidden="true" class="size-8 text-violet-500 dark:text-violet-400">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.059-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
        </svg>
    </div>
    <h3 class="text-base font-semibold text-primary">No post comments yet</h3>
    <p class="mt-2 text-sm text-secondary max-w-sm">
        Public comments from the live post will appear here once the content is published and tracked.
    </p>
</div>

} @else {
<div class="h-full w-full flex flex-col items-start justify-start overflow-y-auto scrollbar-transparent p-2 space-y-4">

    <!-- Comment Analysis Card -->
    <div class="w-full rounded-2xl border border-emerald-500/40 bg-slate-900/80 px-2 py-2">
        <!-- Header -->
        <div class="py-2">
            <div class="flex space-x-3">
                <div class="shrink-0 flex flex-col items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-emerald-400">
                        <path
                            d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                        <path d="M20 2v4" />
                        <path d="M22 4h-4" />
                        <circle cx="4" cy="20" r="2" />
                    </svg>
                </div>
                <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-gray-900 dark:text-white">
                        Comment Analysis
                    </p>
                    <p class="text-sm text-gray-500 dark:text-gray-400">
                    </p>
                </div>
                <div class="flex shrink-0 self-center">

                </div>
            </div>
        </div>


        <!-- Content -->
        <div class="mt-4 flex flex-col gap-4 sm:flex-row sm:items-stretch">
            <!-- Overall score -->
            <div class="shrink-0 flex-col items-center justify-center px-2 py-2 text-center ">
                <div class="relative flex h-20 w-20 items-center justify-center">
                    <!-- Radial progress background + foreground (78% of circumference) -->
                    <svg viewBox="0 0 36 36" class="h-24 w-24 -rotate-90 text-slate-700">
                        <!-- Track -->
                        <circle cx="18" cy="18" r="16" class="stroke-current" stroke-width="3" fill="none" />
                        <!-- Progress: 78% of ~100.5 circumference -->
                        <circle cx="18" cy="18" r="16" class="text-emerald-400" stroke-width="3" fill="none"
                            stroke-linecap="round" style="stroke-dasharray: 78.4 999; stroke: currentColor;" />
                    </svg>
                    <!-- Center value -->
                    <div class="absolute flex flex-col gap-y-1 items-center justify-center">
                        <span class="absolute text-3xl font-semibold text-emerald-400">87</span>
                    </div>

                </div>
            </div>

            <!-- Sentiment breakdown -->
            <div class="flex-1 space-y-2">
                <!-- Positive -->
                <div class="space-y-1.5">
                    <div class="flex items-center justify-between gap-4">
                        <div class="flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-3 text-emerald-400">
                                <path
                                    d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                                <path d="M7 10v12" />
                            </svg>
                            <span class="text-xs font-medium text-slate-100">Positive</span>
                        </div>
                        <span class="text-xs font-semibold text-slate-50">78%</span>
                    </div>
                    <div class="h-1 w-full rounded-full bg-slate-800">
                        <div class="h-full w-4/5 rounded-full bg-emerald-400"></div>
                    </div>
                </div>

                <!-- Neutral -->
                <div class="space-y-1.5">
                    <div class="flex items-center justify-between gap-4">
                        <div class="flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-3 text-gray-400">
                                <path
                                    d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                            </svg>
                            <span class="text-xs font-medium text-slate-100">Neutral</span>
                        </div>
                        <span class="text-xs font-semibold text-slate-50">15%</span>
                    </div>
                    <div class="h-1 w-full rounded-full bg-slate-800">
                        <div class="h-full w-1/3 rounded-full bg-gray-400"></div>
                    </div>
                </div>

                <!-- Negative -->
                <div class="space-y-1.5">
                    <div class="flex items-center justify-between gap-4">
                        <div class="flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-3 text-rose-400">
                                <path
                                    d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                                <path d="M17 14V2" />
                            </svg>
                            <span class="text-xs font-medium text-slate-100">Negative</span>
                        </div>
                        <span class="text-xs font-semibold text-slate-50">7%</span>
                    </div>
                    <div class="h-1 w-full rounded-full bg-slate-800">
                        <div class="h-full w-1/6 rounded-full bg-rose-400"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Themes -->
        <div class="mt-4 border-t border-slate-800 pt-4">
            <p class="text-xs text-slate-400">
                <span class="font-medium text-slate-100">Summary:</span>
            </p>
            <div class="mt-2 flex flex-wrap gap-2">
                <span class="text-xs text-secondary">The comments are mostly positive, with a small percentage of
                    neutral and negative comments.</span>
            </div>
        </div>
    </div>
    <!-- Comment Analysis Card - END -->

    <!-- List of Comments -->
    <div class="py-2">
        <div class="flex space-x-3">
            <div class="shrink-0 flex flex-col items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 text-primary">
                    <path
                        d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719" />
                </svg>
            </div>
            <div class="min-w-0 flex-1">
                <p class="text-sm font-semibold text-gray-900 dark:text-white">
                    All Comments
                </p>
            </div>

        </div>
    </div>

    @if (individualResult().commentSentiment.comments && individualResult().commentSentiment.comments.length > 0) {
    <ul role="list" class="space-y-6">
        @for (comment of individualResult().commentSentiment.comments; track $index) {
        <li class="relative flex gap-x-4">
            @if ($index < individualResult().commentSentiment.comments.length - 1) { <div
                class="absolute -bottom-6 left-0 top-0 flex w-6 justify-center">
                <div class="w-px bg-gray-200 dark:bg-white/15"></div>
</div>
}


<img src="https://ionicframework.com/docs/img/demos/avatar.svg" alt=""
    class="relative mt-3 size-6 flex-none rounded-full bg-gray-50 outline outline-1 -outline-offset-1 outline-black/5 dark:bg-gray-800 dark:outline-white/10" />
<div class="flex-auto rounded-md p-2 ring-1 ring-inset ring-gray-200 dark:ring-white/15">
    <div class="flex justify-between gap-x-4">
        <div class="py-0.5 text-xs/5 text-gray-500 dark:text-gray-400">
            <span class="font-medium text-gray-900 dark:text-white">{{ comment.user.nickname }}</span>
        </div>
        <time class="flex-none py-0.5 text-xs/5 text-gray-500 dark:text-gray-400">{{ comment.createdDate
            | date:'dd MMM' }}</time>
    </div>
    <p class="text-sm/6 text-gray-500 dark:text-gray-400">{{ comment.text }}</p>

    <div class="flex flex-row items-center gap-x-4 divide-x divide-gray-200">
        <span class="text-xs text-gray-400">{{ formatService.convertIntToString(comment.like_count) }}
            likes</span>
        <span class="pl-4 text-xs text-gray-400">{{
            formatService.convertIntToString(comment.reply_count) }} replies</span>
    </div>
</div>
</li>
}
</ul>
}
<!-- List of Comments - END -->
</div>
}